@if (control$$()) {
    <mat-slide-toggle
        (change)="emit_valueChange($event.checked)"
        [aria-label]="input_ariaLabel$$() || null"
        [color]="input_color$$()"
        [disableRipple]="input_disableRipple$$()"
        [formControl]="control$$()"
        [hideIcon]="input_hideIcon$$()"
        [labelPosition]="input_labelPosition$$()"
        [required]="input_required$$()"
        [tabIndex]="tabIndex$$()"
    >
        {{input_label$$()}}
    </mat-slide-toggle>
}
